(() => {
  if (window.heroImageLayoutReady) return;
  window.heroImageLayoutReady = true;

  let frame = 0;
  const desktop = window.matchMedia('(min-width: 769px)');

  const updateWidths = () => {
    frame = 0;
    if (!desktop.matches) return;

    const width = document.documentElement.clientWidth;
    document.querySelectorAll('.hero-image-section--full-width').forEach((section) => {
      const previousOffset = Number.parseFloat(window.getComputedStyle(section).marginLeft) || 0;
      const origin = section.getBoundingClientRect().left - previousOffset;
      const widthValue = `${width}px`;
      const offsetValue = `${-origin}px`;

      if (section.style.getPropertyValue('--hero-viewport-width') !== widthValue) {
        section.style.setProperty('--hero-viewport-width', widthValue);
      }
      if (section.style.getPropertyValue('--hero-full-width-offset') !== offsetValue) {
        section.style.setProperty('--hero-full-width-offset', offsetValue);
      }
    });
  };

  const scheduleUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(updateWidths);
  };

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  desktop.addEventListener('change', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  if ('ResizeObserver' in window) {
    new ResizeObserver(scheduleUpdate).observe(document.documentElement);
  }
  scheduleUpdate();
})();
